// // // 
// // import React, { useEffect, useState } from "react";
// // import API from "../services/api";
// // import "../styles/employee.css";

// // function EmployeesPage() {

// //   const [users, setUsers] = useState([]);
// //   const [search, setSearch] = useState("");
// //   const [selectedUser, setSelectedUser] = useState(null);
// //   const [form, setForm] = useState({});

// //   useEffect(() => {
// //     fetchUsers();
// //   }, []);

// //   const fetchUsers = async () => {
// //     try {
// //       const res = await API.get("/users");
// //       setUsers(res.data);
// //     } catch (err) {
// //       console.log(err);
// //     }
// //   };

// //   // 🔍 SEARCH
// //   const filteredUsers = users.filter(u =>
// //     u.name.toLowerCase().includes(search.toLowerCase())
// //   );

// //   // ✏️ EDIT CLICK
// //   const handleEdit = (user) => {
// //     setSelectedUser(user);
// //     setForm({
// //       name: user.name,
// //       email: user.email,
// //       phone: user.phone,
// //       role_id: user.role_id
// //     });
// //   };

// //   // ✅ UPDATE
// //   const handleUpdate = async (e) => {
// //     e.preventDefault();

// //     try {
// //       await API.put(`/users/${selectedUser.id}`, form);
// //       alert("Updated ✅");

// //       setSelectedUser(null);
// //       fetchUsers();

// //     } catch (err) {
// //       console.log(err);
// //     }
// //   };

// //   return (
// //     <div className="employee-page">

// //       {/* HEADER */}
// //       <div className="top-bar">
// //         <h2>Employees 👨‍💼</h2>

// //         <input
// //           placeholder="Search..."
// //           value={search}
// //           onChange={(e) => setSearch(e.target.value)}
// //         />
// //       </div>

// //       {/* TABLE */}
// //       <div className="table-card">
// //         <table>
// //           <thead>
// //             <tr>
// //               <th>Name</th>
// //               <th>Email</th>
// //               <th>Phone</th>
// //               <th>Role</th>
// //               <th>Status</th>
// //               <th>Action</th>
// //             </tr>
// //           </thead>

// //           <tbody>
// //             {filteredUsers.map((u) => (
// //               <tr key={u.id}>
// //                 <td>{u.name}</td>
// //                 <td>{u.email}</td>
// //                 <td>{u.phone}</td>
// //                 <td>{u.role}</td>

// //                 <td>
// //                   {u.is_active ? "🟢 Active" : "🔴 Inactive"}
// //                 </td>

// //                 {/* ✅ FIXED ACTION BUTTON */}
// //                 <td>
// //                   <button onClick={() => handleEdit(u)}>✏️</button>
// //                 </td>

// //               </tr>
// //             ))}
// //           </tbody>

// //         </table>
// //       </div>

// //       {/* ✅ EDIT MODAL */}
// //       {selectedUser && (
// //         <div className="modal">
// //           <div className="modal-box">

// //             <h3>Edit Employee</h3>

// //             <form onSubmit={handleUpdate}>

// //               <input
// //                 value={form.name || ""}
// //                 onChange={(e) =>
// //                   setForm({ ...form, name: e.target.value })
// //                 }
// //                 placeholder="Name"
// //               />

// //               <input
// //                 value={form.email || ""}
// //                 onChange={(e) =>
// //                   setForm({ ...form, email: e.target.value })
// //                 }
// //                 placeholder="Email"
// //               />

// //               <input
// //                 value={form.phone || ""}
// //                 onChange={(e) =>
// //                   setForm({ ...form, phone: e.target.value })
// //                 }
// //                 placeholder="Phone"
// //               />

// //               <select
// //                 value={form.role_id || ""}
// //                 onChange={(e) =>
// //                   setForm({ ...form, role_id: Number(e.target.value) })
// //                 }
// //               >
// //                 <option value="2">Sales Manager</option>
// //                 <option value="3">Sales Executive</option>
// //                 <option value="4">Telesales</option>
// //                 <option value="5">IT Manager</option>
// //               </select>
// // <div style={{ marginTop: "15px" }}>
// //   <button type="submit">Update</button>

// //   <button
// //     type="button"
// //     onClick={() => setSelectedUser(null)}
// //     style={{ marginLeft: "10px" }}
// //   >
// //     Cancel
// //   </button>
// // </div>

// //             </form>

// //           </div>
// //         </div>
// //       )}

// //     </div>
// //   );
// // }

// // export default EmployeesPage;

// import React, { useEffect, useState } from "react";
// import API from "../services/api";
// import "../styles/employee.css";

// function EmployeesPage() {

//   const [users, setUsers] = useState([]);
//   const [search, setSearch] = useState("");
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [form, setForm] = useState({});

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const res = await API.get("/users");
//       setUsers(res.data);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // 🔍 SEARCH
//   const filteredUsers = users.filter(u =>
//     u.name.toLowerCase().includes(search.toLowerCase())
//   );

//   // ✏️ EDIT
//   const handleEdit = (user) => {
//     setSelectedUser(user);
//     setForm({
//       name: user.name,
//       email: user.email,
//       phone: user.phone,
//       role_id: user.role_id
//     });
//   };

//   // ✅ UPDATE
//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     try {
//       console.log("UPDATING:", form);

//       await API.put(`/users/${selectedUser.id}`, form);

//       alert("✅ Employee Updated");

//       setSelectedUser(null);
//       fetchUsers();

//     } catch (err) {
//       console.log(err);
//       alert("❌ Update Failed");
//     }
//   };

//   return (
//     <div className="employee-page">

//       {/* HEADER */}
//       <div className="top-bar">
//         <h2>Employees 👨‍💼</h2>

//         <input
//           placeholder="Search employee..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//       </div>

//       {/* TABLE */}
//       <div className="table-card">
//         <table>
//           <thead>
//             <tr>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Phone</th>
//               <th>Role</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filteredUsers.map((u) => (
//               <tr key={u.id}>
//                 <td>{u.name}</td>
//                 <td>{u.email}</td>
//                 <td>{u.phone}</td>
//                 <td>{u.role}</td>

//                 <td>
//                   {u.is_active ? "🟢 Active" : "🔴 Inactive"}
//                 </td>

//                 <td>
//                   <button
//                     className="edit-btn"
//                     onClick={() => handleEdit(u)}
//                   >
//                     ✏️ Edit
//                   </button>
//                 </td>

//               </tr>
//             ))}
//           </tbody>

//         </table>
//       </div>

//       {/* ✅ MODAL */}
//       {selectedUser && (
//         <div className="modal">
//           <div className="modal-box">

//             <h3>Edit Employee</h3>

//             <form onSubmit={handleUpdate}>

//               <input
//                 value={form.name || ""}
//                 onChange={(e) =>
//                   setForm({ ...form, name: e.target.value })
//                 }
//                 placeholder="Name"
//               />

//               <input
//                 value={form.email || ""}
//                 onChange={(e) =>
//                   setForm({ ...form, email: e.target.value })
//                 }
//                 placeholder="Email"
//               />

//               <input
//                 value={form.phone || ""}
//                 onChange={(e) =>
//                   setForm({ ...form, phone: e.target.value })
//                 }
//                 placeholder="Phone"
//               />

//               <select
//                 value={form.role_id || ""}
//                 onChange={(e) =>
//                   setForm({ ...form, role_id: Number(e.target.value) })
//                 }
//               >
//                 <option value="2">Sales Manager</option>
//                 <option value="3">Sales Executive</option>
//                 <option value="4">Telesales</option>
//                 <option value="5">IT Manager</option>
//               </select>

//               {/* ✅ BUTTONS */}
//               <div className="modal-actions">
//                 <button type="submit">Update</button>

//                 <button
//                   type="button"
//                   onClick={() => setSelectedUser(null)}
//                 >
//                   Cancel
//                 </button>
//               </div>

//             </form>

//           </div>
//         </div>
//       )}

//     </div>
//   );
// }

// export default EmployeesPage;

// import React, { useEffect, useState } from "react";
// import API from "../services/api";
// import "../styles/employee.css";

// function EmployeesPage() {

//   const [users, setUsers] = useState([]);
//   const [search, setSearch] = useState("");
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [form, setForm] = useState({});

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const res = await API.get("/users");
//       setUsers(res.data);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // 🔍 SEARCH
//   const filteredUsers = users.filter(u =>
//     u.name?.toLowerCase().includes(search.toLowerCase())
//   );

//   // ✏️ EDIT
//   const handleEdit = (user) => {
//     setSelectedUser(user);
//     setForm({
//       name: user.name || "",
//       email: user.email || "",
//       phone: user.phone || "",
//       role_id: user.role_id || 3
//     });
//   };

//   // ✅ UPDATE
//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     try {
//       await API.put(`/users/${selectedUser.id}`, form);

//       alert("Updated ✅");

//       setSelectedUser(null);
//       fetchUsers();

//     } catch (err) {
//       console.log("Update Error:", err);
//       alert("Update failed ❌");
//     }
//   };

//   return (
//     <div className="employee-page">

//       {/* HEADER */}
//       <div className="top-bar">
//         <h2>Employees 👨‍💼</h2>

//         <input
//           placeholder="Search..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//       </div>

//       {/* TABLE */}
//       <div className="table-card">
//         <table>
//           <thead>
//             <tr>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Phone</th>
//               <th>Role</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filteredUsers.map((u) => (
//               <tr key={u.id}>
//                 <td>{u.name}</td>
//                 <td>{u.email}</td>
//                 <td>{u.phone}</td>
//                 <td>{u.role}</td>

//                 <td>
//                   {u.is_active ? "🟢 Active" : "🔴 Inactive"}
//                 </td>

//                 <td>
//                   <button
//                     className="edit-btn"
//                     onClick={() => handleEdit(u)}
//                   >
//                     ✏️ Edit
//                   </button>
//                 </td>

//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* MODAL */}
//       {selectedUser && (
//         <div className="modal">
//           <div className="modal-box">

//             <h3>Edit Employee</h3>

//             <form onSubmit={handleUpdate}>

//               <input
//                 value={form.name}
//                 onChange={(e) =>
//                   setForm({ ...form, name: e.target.value })
//                 }
//                 placeholder="Name"
//               />

//               <input
//                 value={form.email}
//                 onChange={(e) =>
//                   setForm({ ...form, email: e.target.value })
//                 }
//                 placeholder="Email"
//               />

//               <input
//                 value={form.phone}
//                 onChange={(e) =>
//                   setForm({ ...form, phone: e.target.value })
//                 }
//                 placeholder="Phone"
//               />

//               <select
//                 value={form.role_id}
//                 onChange={(e) =>
//                   setForm({ ...form, role_id: Number(e.target.value) })
//                 }
//               >
//                 <option value={2}>Sales Manager</option>
//                 <option value={3}>Sales Executive</option>
//                 <option value={4}>Telesales</option>
//                 <option value={5}>IT Manager</option>
//               </select>

//               <div className="modal-actions">
//                 <button type="submit" className="update-btn">
//                   Update
//                 </button>

//                 <button
//                   type="button"
//                   className="cancel-btn"
//                   onClick={() => setSelectedUser(null)}
//                 >
//                   Cancel
//                 </button>
//               </div>

//             </form>

//           </div>
//         </div>
//       )}

//     </div>
//   );
// }

// export default EmployeesPage;

import React, { useEffect, useState } from "react";
import API from "../services/api";

/* ── palette ── */
const T = {
  page:       "#f0f4f8",
  card:       "#ffffff",
  cardBorder: "#e2e8f0",
  titleText:  "#0f172a",
  bodyText:   "#334155",
  mutedText:  "#64748b",
  hintText:   "#94a3b8",
  inputBg:    "#f8fafc",
  divider:    "#e2e8f0",
};

const ROLE_LABELS = { 1: "Boss", 2: "IT Manager", 3: "Sales Executive", 4: "Telesales", 5: "Sales Manager" };

const ROLE_STYLES = {
  "Sales Manager":   { bg: "#dbeafe", text: "#1d4ed8" },
  "Sales Executive": { bg: "#ede9fe", text: "#6d28d9" },
  "Telesales":       { bg: "#fef3c7", text: "#b45309" },
  "IT Manager":      { bg: "#d1fae5", text: "#047857" },
  "Boss":            { bg: "#fee2e2", text: "#b91c1c" },
};

const AVATAR_COLORS = ["#3b82f6","#8b5cf6","#10b981","#f59e0b","#ef4444","#06b6d4"];

function getInitials(name = "") {
  return name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);
}

function AvatarCircle({ name, size = 38 }) {
  const idx = (name?.charCodeAt(0) || 0) % AVATAR_COLORS.length;
  const color = AVATAR_COLORS[idx];
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: `${color}18`,
      border: `2px solid ${color}44`,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: size * 0.34, fontWeight: 700, color, flexShrink: 0,
    }}>
      {getInitials(name)}
    </div>
  );
}

function EmployeesPage() {
  const [users, setUsers]               = useState([]);
  const [search, setSearch]             = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [form, setForm]                 = useState({});
  const [loading, setLoading]           = useState(false);

  useEffect(() => { fetchUsers(); }, []);

  const fetchUsers = async () => {
    try { const res = await API.get("/users"); setUsers(res.data); }
    catch (err) { console.log(err); }
  };

  const filteredUsers = users.filter(u =>
    u.name?.toLowerCase().includes(search.toLowerCase()) ||
    u.email?.toLowerCase().includes(search.toLowerCase())
  );

  const handleEdit = (user) => {
    setSelectedUser(user);
    setForm({
      name: user.name || "",
      email: user.email || "",
      phone: user.phone || "",
      role_id: user.role_id || 3,
      newPassword: "",
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (form.newPassword && form.newPassword.trim().length > 0 && form.newPassword.trim().length < 6) {
      alert("New password must be at least 6 characters");
      return;
    }

    setLoading(true);
    try {
      // 1️⃣ Update basic profile info
      await API.put(`/users/${selectedUser.id}`, {
        name: form.name,
        email: form.email,
        phone: form.phone,
        role_id: form.role_id,
      });

      // 2️⃣ Reset password — only if admin typed a new one
      if (form.newPassword && form.newPassword.trim().length > 0) {
        await API.put(`/users/reset-password/${selectedUser.id}`, {
          newPassword: form.newPassword.trim(),
        });
      }

      setSelectedUser(null);
      fetchUsers();
      alert("Employee updated successfully ✅");
    } catch (err) {
      console.log(err);
      alert(err?.response?.data?.message || "Update failed ❌");
    } finally { setLoading(false); }
  };

  const activeCount = users.filter(u => u.is_active).length;

  return (
    <div style={{
      minHeight: "100vh",
      background: T.page,
      color: T.bodyText,
      fontFamily: "'Inter', -apple-system, sans-serif",
      padding: "28px 32px",
    }}>

      {/* HEADER */}
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 28 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700, color: T.titleText, letterSpacing: "-0.3px" }}>
            Team members
          </h1>
          <p style={{ margin: "4px 0 0", fontSize: 14, color: T.mutedText }}>
            Manage your team and their roles
          </p>
        </div>

        {/* STAT PILLS */}
        <div style={{ display: "flex", gap: 10 }}>
          {[
            { label: "Total",    value: users.length,                  color: "#3b82f6", bg: "#dbeafe" },
            { label: "Active",   value: activeCount,                   color: "#059669", bg: "#d1fae5" },
            { label: "Inactive", value: users.length - activeCount,    color: "#dc2626", bg: "#fee2e2" },
          ].map((s, i) => (
            <div key={i} style={{
              background: s.bg, borderRadius: 12,
              padding: "10px 20px", display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
            }}>
              <span style={{ fontSize: 20, fontWeight: 700, color: s.color }}>{s.value}</span>
              <span style={{ fontSize: 11, color: s.color, fontWeight: 600, opacity: 0.8 }}>{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* TABLE CARD */}
      <div style={{
        background: T.card,
        border: `1px solid ${T.cardBorder}`,
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      }}>

        {/* SEARCH BAR */}
        <div style={{
          padding: "16px 24px",
          borderBottom: `1px solid ${T.divider}`,
          display: "flex", alignItems: "center", gap: 12,
          background: "#fafbfc",
        }}>
          <div style={{ position: "relative", flex: 1, maxWidth: 340 }}>
            <span style={{
              position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)",
              fontSize: 15, color: T.hintText,
            }}>🔍</span>
            <input
              placeholder="Search by name or email..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "100%", boxSizing: "border-box",
                background: T.card, border: `1px solid ${T.cardBorder}`,
                borderRadius: 10, padding: "9px 14px 9px 36px",
                fontSize: 13, color: T.titleText, outline: "none",
              }}
            />
          </div>
          <span style={{ fontSize: 13, color: T.mutedText, marginLeft: "auto" }}>
            {filteredUsers.length} of {users.length} members
          </span>
        </div>

        {/* TABLE */}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#f8fafc" }}>
                {["Member", "Email", "Phone", "Role", "Status", "Action"].map(h => (
                  <th key={h} style={{
                    padding: "12px 20px", textAlign: "left",
                    color: T.mutedText, fontWeight: 700, fontSize: 11,
                    letterSpacing: "0.07em", textTransform: "uppercase",
                    borderBottom: `1px solid ${T.divider}`,
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center", padding: "48px 20px", color: T.mutedText }}>
                    {search ? `No results for "${search}"` : "No team members yet."}
                  </td>
                </tr>
              ) : filteredUsers.map((u) => {
                const roleLabel = u.role || ROLE_LABELS[u.role_id] || "—";
                const roleStyle = ROLE_STYLES[roleLabel] || { bg: "#f1f5f9", text: T.mutedText };
                return (
                  <tr key={u.id}
                    style={{ borderBottom: `1px solid ${T.divider}`, transition: "background 0.12s" }}
                    onMouseEnter={e => e.currentTarget.style.background = "#f8fafc"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                  >
                    <td style={{ padding: "14px 20px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <AvatarCircle name={u.name} />
                        <div>
                          <p style={{ margin: 0, fontWeight: 600, color: T.titleText, fontSize: 13 }}>{u.name}</p>
                          <p style={{ margin: 0, color: T.hintText, fontSize: 11 }}>ID #{u.id}</p>
                        </div>
                      </div>
                    </td>
                    <td style={{ padding: "14px 20px", color: T.mutedText }}>{u.email || "—"}</td>
                    <td style={{ padding: "14px 20px", color: T.mutedText }}>{u.phone || "—"}</td>
                    <td style={{ padding: "14px 20px" }}>
                      <span style={{
                        background: roleStyle.bg, color: roleStyle.text,
                        padding: "4px 10px", borderRadius: 20,
                        fontSize: 11, fontWeight: 700,
                      }}>{roleLabel}</span>
                    </td>
                    <td style={{ padding: "14px 20px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <div style={{
                          width: 7, height: 7, borderRadius: "50%",
                          background: u.is_active ? "#10b981" : "#ef4444",
                          boxShadow: u.is_active ? "0 0 5px #10b98166" : "none",
                        }} />
                        <span style={{
                          fontSize: 12, fontWeight: 600,
                          color: u.is_active ? "#059669" : "#dc2626",
                        }}>
                          {u.is_active ? "Active" : "Inactive"}
                        </span>
                      </div>
                    </td>
                    <td style={{ padding: "14px 20px" }}>
                      <button
                        onClick={() => handleEdit(u)}
                        style={{
                          background: T.inputBg, border: `1px solid ${T.cardBorder}`,
                          color: T.bodyText, padding: "6px 14px", borderRadius: 8,
                          fontSize: 12, cursor: "pointer", fontWeight: 600,
                          transition: "all 0.15s",
                        }}
                        onMouseEnter={e => { e.target.style.background = "#e0e7ef"; }}
                        onMouseLeave={e => { e.target.style.background = T.inputBg; }}
                      >
                        ✏️ Edit
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* EDIT MODAL */}
      {selectedUser && (
        <div style={{
          position: "fixed", inset: 0,
          background: "rgba(15,23,42,0.45)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 1000, backdropFilter: "blur(4px)",
        }} onClick={(e) => e.target === e.currentTarget && setSelectedUser(null)}>
          <div style={{
            background: T.card,
            border: `1px solid ${T.cardBorder}`,
            borderRadius: 20, width: 440, padding: 28,
            boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
          }}>

            {/* Modal header */}
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 24 }}>
              <AvatarCircle name={selectedUser.name} size={44} />
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: T.titleText }}>Edit member</h3>
                <p style={{ margin: "3px 0 0", fontSize: 13, color: T.mutedText }}>{selectedUser.name}</p>
              </div>
              <button onClick={() => setSelectedUser(null)} style={{
                background: T.inputBg, border: `1px solid ${T.cardBorder}`,
                color: T.mutedText, width: 30, height: 30, borderRadius: 8,
                fontSize: 15, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
              }}>✕</button>
            </div>

            <form onSubmit={handleUpdate} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {[
                { label: "Full name",     key: "name",  type: "text",  placeholder: "Enter full name"    },
                { label: "Email address", key: "email", type: "email", placeholder: "name@company.com"   },
                { label: "Phone number",  key: "phone", type: "tel",   placeholder: "10-digit number"    },
              ].map(({ label, key, type, placeholder }) => (
                <div key={key}>
                  <label style={{
                    display: "block", fontSize: 11, fontWeight: 700,
                    color: T.mutedText, marginBottom: 6,
                    letterSpacing: "0.06em", textTransform: "uppercase",
                  }}>{label}</label>
                  <input
                    type={type}
                    value={form[key] || ""}
                    placeholder={placeholder}
                    onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                    style={{
                      width: "100%", boxSizing: "border-box",
                      background: T.inputBg, border: `1px solid ${T.cardBorder}`,
                      borderRadius: 10, padding: "10px 14px",
                      fontSize: 13, color: T.titleText, outline: "none",
                      transition: "border-color 0.15s",
                    }}
                    onFocus={e => e.target.style.borderColor = "#3b82f6"}
                    onBlur={e  => e.target.style.borderColor = T.cardBorder}
                  />
                </div>
              ))}

              <div>
                <label style={{
                  display: "block", fontSize: 11, fontWeight: 700,
                  color: T.mutedText, marginBottom: 6,
                  letterSpacing: "0.06em", textTransform: "uppercase",
                }}>Role</label>
                <select
                  value={form.role_id}
                  onChange={(e) => setForm({ ...form, role_id: Number(e.target.value) })}
                  style={{
                    width: "100%",
                    background: T.inputBg, border: `1px solid ${T.cardBorder}`,
                    borderRadius: 10, padding: "10px 14px",
                    fontSize: 13, color: T.titleText, outline: "none", cursor: "pointer",
                  }}
                >
                  <option value={2}>IT Manager</option>
                  <option value={3}>Sales Executive</option>
                  <option value={4}>Telesales</option>
                  <option value={5}>Sales Manager</option>
                </select>
              </div>

              {/* 🔒 RESET PASSWORD */}
              <div style={{
                background: "#eff6ff", border: "1px solid #bfdbfe",
                borderRadius: 10, padding: "12px 14px",
              }}>
                <label style={{
                  display: "block", fontSize: 11, fontWeight: 700,
                  color: "#1d4ed8", marginBottom: 6,
                  letterSpacing: "0.06em", textTransform: "uppercase",
                }}>🔒 Reset password</label>
                <input
                  type="text"
                  value={form.newPassword || ""}
                  placeholder="Leave blank to keep current password"
                  onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
                  style={{
                    width: "100%", boxSizing: "border-box",
                    background: "#fff", border: "1px solid #bfdbfe",
                    borderRadius: 8, padding: "10px 14px",
                    fontSize: 13, color: T.titleText, outline: "none",
                  }}
                />
                <p style={{ margin: "6px 0 0", fontSize: 11, color: "#1d4ed8" }}>
                  For security, the existing password can never be shown — only a new one can be set (min 6 characters).
                </p>
              </div>

              <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
                <button type="submit" disabled={loading} style={{
                  flex: 1,
                  background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
                  border: "none", color: "#fff",
                  padding: "12px 20px", borderRadius: 10,
                  fontSize: 14, fontWeight: 700, cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(59,130,246,0.30)",
                  opacity: loading ? 0.7 : 1,
                }}>
                  {loading ? "Saving…" : "Save changes"}
                </button>
                <button type="button" onClick={() => setSelectedUser(null)} style={{
                  flex: 1,
                  background: T.inputBg, border: `1px solid ${T.cardBorder}`,
                  color: T.bodyText, padding: "12px 20px", borderRadius: 10,
                  fontSize: 14, fontWeight: 600, cursor: "pointer",
                }}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default EmployeesPage;